module.exports = __webpack_public_path__ + "static/media/18-RLED 6.7ad9e602.jpg";